import React from 'react';
import translate from '../../utilities/translator';

export default function MainFilterPreloader() {
  const FilterLoader = ({ icon, label, value }) => (
    <div className="main-filter__item">
      <div className="main-filter__loader" />
      <div className="main-filter__selection">
        <span className="main-filter__selection-label">{label}</span>
        <div className="main-filter__selection-outer-wrap">
          <i className={`${icon} main-filter__selection-icon`} />
          <div className="main-filter__selection-value">
            {value ? value : <span className="placeholder">{value}</span>}
          </div>
        </div>
        <div className="main-filter__mobile">
          <i className={`${icon} main-filter__selection-icon`} />
        </div>
      </div>
    </div>
  );

  return (
    <>
      <div className="departing col-lg-12">
        {translate('holidayFinder.mainFilter.departing_from')}
      </div>
      <div className="main-filter is-loading col-lg-12">
        <FilterLoader
          icon="ri-suitcase-2-line"
          label={translate('holidayFinder.mainFilter.What')}
          value={translate('holidayFinder.mainFilter.all_vacation')}
        />
        <FilterLoader
          icon="ri-map-pin-2-line"
          label={translate('holidayFinder.mainFilter.where')}
          value={translate('holidayFinder.mainFilter.everywhere')}
        />
        <FilterLoader
          icon="ri-calendar-line"
          label={translate('holidayFinder.mainFilter.when')}
          value={translate('holidayFinder.mainFilter.any')}
        />
        <FilterLoader
          icon="ri-user-line"
          label={translate('holidayFinder.mainFilter.whos_going') + '?'}
          value={`2 ${translate(
            'holidayFinder.general.adults_plural', { count: 2 }
          )}, 1 ${translate('holidayFinder.general.rooms_plural', {
            count: 1,
          })}`}
        />
        <FilterLoader
          icon="ri-wallet-3-line"
          label={translate('holidayFinder.mainFilter.your_budget')}
          value={translate('holidayFinder.mainFilter.any')}
        />
      </div>
    </>
  );
}
